import {createNamespacedHelpers} from 'vuex';

const {mapMutations, mapState} = createNamespacedHelpers('app')

const dirtyForm = {
    methods: {
        ...mapMutations(['CHANGE_FORM', 'STASH_FORM'])
    },
    computed: {
        ...mapState({
            formDirty: state => state.isFormChanged
        }),
    },
    beforeRouteLeave (to, from, next) {
        if(this.formDirty){
            const answer = window.confirm('У вас есть несохраненные изменения!' +
                'Вы уверены, что хотите покинуть эту страницу?')
            if (answer) {
                this.STASH_FORM();
                next()
            } else {
                next(false);
                return;
            }
        }
        next();
    }
}
export default dirtyForm;
